import {
    Highlight,
    Hits,
    InstantSearch,
    SearchBox,
    connectStateResults
  } from "react-instantsearch-dom"
  
  import React from "react"
  import { instantMeiliSearch } from "@meilisearch/instant-meilisearch"
  
  const GATSBY_MEILISEARCH_HOST = "https://ms-1361f7051e52-1194.fra.meilisearch.io"
  const GATSBY_MEILISEARCH_API_KEY = "58ac1839508596c17e4d516ea26957b7bf9c68ea"
  const GATSBY_SEARCH_INDEX_NAME = "products"

  const searchClient = instantMeiliSearch(
    GATSBY_MEILISEARCH_HOST,
    GATSBY_MEILISEARCH_API_KEY
  )
  
  const Search = () => {
    const Results = connectStateResults(({ searchState, searchResults, children }) =>
      searchState && searchState.query && searchResults && searchResults.nbHits !== 0 ? (
        <div className="absolute top-full w-full p-2 bg-gray-200 shadow-md">
          {children}
        </div>
      ) : (
        <div></div>
      )
    );
  
    return (
      <div className="relative">
        <InstantSearch indexName={GATSBY_SEARCH_INDEX_NAME} searchClient={searchClient}>
          <SearchBox submit={null} reset={null} />
          <Results>
            <Hits hitComponent={Hit} />
          </Results>
        </InstantSearch>
      </div>
    )
  }
  
  const Hit = ({ hit }) => {
    return (
      <div key={hit.id} className="relative">
        <div className="hit-name">
          <Highlight attribute="title" hit={hit} tagName="mark" />
        </div>
      </div>
    )
  }
  
  export default Search;